(function () {
    'use strict';

    // DEMO ONLY - mocks all REST calls so the email verification UI can be reviewed
    // without a backend. Remove this file and revert router.js + responseAdapter.service.js
    // when the real backend is ready.
    angular.module('l4b')
        .controller('EmailVerificationDemoController', EmailVerificationDemoController);

    EmailVerificationDemoController.$inject = ['FlowService', 'StorageService', 'Constants', 'BrandService', '$interval', '$scope', 'DTOFactory', 'Utils', '$window', '$timeout'];

    function EmailVerificationDemoController(FlowService, StorageService, Constants, BrandService, $interval, $scope, DTOFactory, Utils, $window, $timeout) {

        var vm = this,
            emailForm = null,
            verificationForm = null,
            interval = null,
            remainingMs = null;

        var DEMO_RESEND_SECONDS = 120;
        var DEMO_NOREPLY_EMAIL = 'noreply@verizon.com';

        angular.extend(vm, {
            $onInit: init,
            nextStep: nextStep,
            updateEmail: updateEmail,
            back: back,
            pii: DTOFactory.Application().Applicant,
            noreplyEmail: StorageService.get(Constants.SK.NoreplyEmail) || DEMO_NOREPLY_EMAIL,
            onVerificationCodeChanged: onVerificationCodeChanged,
            resend: resend,
            verificationCode: '',
            brand:  BrandService.getCurrent().Name,
            patterns: {
                verificationCode: /^[0-9]{6}$/,
                email: Constants.Pattern.EMAIL
            },
            allowResend: allowResend,
            timeFormat: timeFormat,
            showCodeResent: false,
            showEmail: false,
            toggleEmail: toggleEmail,
            onEmailChanged: onEmailChanged,
            maxLengths: Constants.LengthRestrictions
        });

        function init() {
            mockCreateOrResendSuccess();
        }

        function back() {
            FlowService.goToPersonalInformation();
        }

        function nextStep(_emailForm, _verificationForm) {
            if (!Utils.validateForm(_verificationForm)) {
                return;
            }

            emailForm = emailForm || _emailForm;
            verificationForm = verificationForm || _verificationForm;

            FlowService.nextStep();
        }

        function updateEmail(_emailForm, _verificationForm) {
            if (!Utils.validateForm(_emailForm)) {
                return;
            }

            emailForm = emailForm || _emailForm;
            verificationForm = verificationForm || _verificationForm;

            if (vm.pii.Email == vm.updatedEmail) {
                emailForm.email.$setValidity('equals', false);
                return;
            }

            vm.pii.Email = vm.updatedEmail;
            StorageService.set(Constants.SK.Applicant, vm.pii);

            mockResendSuccess();
            $window.scrollTo({ top: 0, behavior: 'smooth' });
        }

        function clearEmailForm() {
            vm.updatedEmail = '';
            vm.showEmail = false;
            onEmailChanged();
        }

        function clearVerificationForm() {
            vm.verificationCode = '';
            onVerificationCodeChanged();
        }

        function onVerificationCodeChanged() {
            if (!verificationForm || !verificationForm.verificationCode) {
                return;
            }

            verificationForm.verificationCode.$setValidity('invalidcode', true);
            verificationForm.verificationCode.$setValidity('required', true);
        }

        function onEmailChanged() {
            if (!emailForm || !emailForm.email) {
                return;
            }

            emailForm.email.$setValidity('invalidEmail', true);
            emailForm.email.$setValidity('invalidDomain', true);
            emailForm.email.$setValidity('equals', true);
        }

        function resend() {
            mockResendSuccess();
        }

        function mockResendSuccess() {
            vm.showCodeResent = true;
            $timeout(function () {
                vm.showCodeResent = false;
            }, 3000);

            mockCreateOrResendSuccess();
        }

        function mockCreateOrResendSuccess() {
            if (interval) {
                $interval.cancel(interval);
            }

            clearEmailForm();
            clearVerificationForm();

            remainingMs = DEMO_RESEND_SECONDS * 1000;
            initTimer();
        }

        function allowResend() {
            return remainingMs <= 0;
        }

        function initTimer() {
            interval = $interval(function () {
                if (remainingMs <= 0) {
                    $interval.cancel(interval);
                    return;
                }

                remainingMs -= 1000;
            }, 1000);
        }

        function timeFormat() {
            if (!remainingMs) {
                return;
            }

            var totalSeconds = Math.floor(remainingMs / 1000);
            var minutes = Math.floor(totalSeconds / 60);
            var seconds = totalSeconds % 60;

            return minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0');
        }

        function toggleEmail() {
            vm.showEmail = !vm.showEmail;
        }
    }
})();
